import React from "react";
import Hero from "./Hero";
import TechStack from "./TechStack";
import AboutProgramSection from "./AboutProgram";
import Curriculum from "./Curriculum";
import Timeline from "./Timeline";
import JobGuarantee from "./JobGuarantee";
import ProgramsOverview from "./ProgramsOverview";
import BenefitsSection from "./BenefitsSection";
import Enquire from "./Enquire";
// import AssessmentQuiz from "./AssessmentQuiz";
// import PopupNotifications from "./PopupNotifications";
import HeroBanner from "./HeroBanner";

const Home = () => {
  return (
    <div  style={{    overflowX: "hidden"}}>
      <HeroBanner/>
      <ProgramsOverview />
      <Hero />
      <AboutProgramSection />      
      <BenefitsSection />
      {/* <TechStack /> */}
      <JobGuarantee />
      <Curriculum />
      {/* <Timeline /> */}
      {/* <AssessmentQuiz/> */}
      <Enquire/>
      {/* <PopupNotifications /> */}
    </div>
  );
};

export default Home;
